<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div
        class="animated fadeInRightBig data-box"
        style="height:100%;width:100%;"
      >
        <!-- <img :src="imgurl" class="nopx-ld-logo" @click="changeMaptype" alt="" /> -->
        <div v-for="item in datalist" :key="item.img" class="item-box">
          <img :src="item.limg" class="jt-logo" :style="item.lbtn" alt="" />
          <img
            :src="item.img"
            @click="toshowRightDt(item.name)"
            class="item-logo"
            :style="item.styl"
            alt=""
          />
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { cyldMixin } from "@/util/mixin/cyldMixin";
import { get } from "@/api/index";
import { mapGetters } from "vuex";
export default {
  mixins: [cyldMixin],
  computed: {
    ...mapGetters(["maptype"]),
    imgurl() {
      if (this.maptype === "gy") {
        return require("@/assets/images/map/ld/liugey2.png");
      }
      return require("@/assets/images/map/ld/liugey.png");
    }
  },
  data() {
    return {
      datalist: [
        {
          name: "智慧荔园",
          img: require("@/assets/images/map/ld/l-07.png"),
          limg: require("@/assets/images/map/ld/7.png"),
          lbtn: "bottom:25%;left: 3%;",
          styl: "left:23%"
        },
        {
          name: "五化果园",
          img: require("@/assets/images/map/ld/l-08.png"),
          limg: require("@/assets/images/map/ld/8.png"),
          lbtn: "bottom:5%;left: 8%;",
          styl: "left:45%"
        },
        {
          name: "根子柏桥贡园",
          img: require("@/assets/images/map/ld/l-09.png"),
          limg: require("@/assets/images/map/ld/9.png"),
          lbtn: "bottom:6%;left: 12%;",
          styl: "left:49%"
        },
        {
          name: "羊角禄段古荔园",
          img: require("@/assets/images/map/ld/l-10.png"),
          limg: require("@/assets/images/map/ld/10.png"),
          lbtn: "bottom:47%;left: 14%;",
          styl: "left:49%"
        },
        {
          name: "霞洞上河古荔园",
          img: require("@/assets/images/map/ld/l-11.png"),
          limg: require("@/assets/images/map/ld/11.png"),
          lbtn: "bottom:48%;left: 9%;",
          styl: "left:45%"
        },
        {
          name: "泗水滩底古荔园",
          img: require("@/assets/images/map/ld/l-12.png"),
          limg: require("@/assets/images/map/ld/12.png"),
          lbtn: "bottom:47%;left: -10%;",
          styl: "left:23%"
        }
      ]
    };
  },
  mounted() {
    this.t61List = [];
  },
  methods: {
    changeMaptype() {
      if (this.maptype !== "gy") {
        this.$store.dispatch("map/setLdMaptype", "gy");
      }
    },
    toshowRightDt(name) {
      if (sessionStorage.getItem("lgyData") && this.t61List.length === 0) {
        this.t61List = JSON.parse(sessionStorage.getItem("lgyData"));
      }
      console.log("this.t61List", this.t61List);

      let index = findIndexByName(name, this.t61List);
      if (index === -1) {
        return;
      }
      get("/api/restful/findByIds?id=" + this.t61List[index].id).then(res => {
        if (res.websiteNewsFiles instanceof Array) {
          this.showRightDt(
            Object.assign({}, this.t61List[index], {
              orgCompanyFiles: res.websiteNewsFiles
            })
          );
        } else {
          this.showRightDt(
            Object.assign({}, this.t61List[index], { orgCompanyFiles: [] })
          );
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.data-box
    display flex
    position relative
    flex-direction column
    .nopx-ld-logo
        position absolute
        top calc(46% - 75px)
        left -88px
        cursor pointer
    .item-box
        position relative
        flex 1
        .jt-logo
            position absolute
        .item-logo
            position absolute
            cursor pointer

@media (max-height 950px)
    .rightBar
        >>>
            .data-box
                .item-box
                    .item-logo
                        height: 90%
</style>
